window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

theme.Navigation = (function () {
  var selectors = {
    headerDropdownTrigger: ".js-header-dropdown-trigger",
    headerNavDropdown: ".js-header-nav-dropdown",
    headerNavSideTrigger: ".js-header-nav-side-trigger",
    headerNavSide: ".js-nav-side",
    headerNavTrigger: ".js-mobile-menu-trigger",
    navigation: ".js-header-menu",
    navigationClose: ".js-mobile-menu-close",
    navSideClose: ".js-nav-side-close",
    bodyOverlay: ".js-body-overlay",
  };

  function headerDropdown() {
    let toggleHeaderDropdown = function () {
      if (window.innerWidth > 990) {
        $(selectors.headerDropdownTrigger)
          .on("mouseenter", function () {
            $(this).addClass("is-active");
            $(this).find(selectors.headerNavDropdown).addClass("is-active");
            $("body").addClass("nav-is-active");
          })
          .on("mouseleave", function (e) {
            $(this).removeClass("is-active");
            $(this).find(selectors.headerNavDropdown).removeClass("is-active");
            $("body").removeClass("nav-is-active");
          });
      } else {
        $(selectors.headerDropdownTrigger).on("click", function () {
          $(this).toggleClass("is-active");
          $(this).find(selectors.headerNavDropdown).toggleClass("is-active");
        });
      }
    };

    let toggleSideNav = function () {
      if (window.innerWidth > 990) {
        $(selectors.headerNavSideTrigger)
          .on("mouseenter", function () {
            $(this).addClass("is-active");
            $("body").addClass("lock");
            $("html").addClass("lock");
            $(this).find(selectors.headerNavSide).addClass("is-active");
          })
          .on("mouseleave", function (e) {
            $(this).removeClass("is-active");
            $("body").removeClass("lock");
            $("html").removeClass("lock");
            $(this).find(selectors.headerNavSide).removeClass("is-active");
          });
      } else {
        $(selectors.headerNavSideTrigger).on("click", function (e) {
          if (e.target == e.currentTarget) {
            $(this).find(selectors.headerNavSide).addClass("is-active");
            $("body").addClass("lock");
            $(selectors.bodyOverlay).addClass("is-active");
          }
        });
        $(selectors.navSideClose).on("click", function () {
          $(selectors.headerNavSide).removeClass("is-active");
          $("body").removeClass("lock");
          $(selectors.bodyOverlay).removeClass("is-active");
        });
      }
    };

    let mobileNav = function () {
      $(selectors.headerNavTrigger).on("click", function () {
        $(selectors.navigation).addClass("is-opened");
        $("body").addClass("lock");
      });
      $(selectors.navigationClose).on("click", function () {
        $(selectors.navigation).removeClass("is-opened");
        $("body").removeClass("lock");
      });
    };

    toggleHeaderDropdown();
    toggleSideNav();
    mobileNav();

    window.onresize = toggleHeaderDropdown;
    window.onresize = toggleSideNav;
  }

  headerDropdown();

  return headerDropdown;
})();
theme.FiltersAccordian = (function () {
  var selectors = {
    filtersAccordianTrigger: ".js-filters-accordion-trigger",
    filtersAccordianContent: ".js-filters-accordion-content",
    filtersTrigger: ".js-filters-trigger",
    collectionFilters: ".js-collection-filters",
    collectionFiltersClose: ".js-collection-filters-close",
  };

  function filtersAccordian() {
    $(selectors.filtersAccordianTrigger).on("click", function () {
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $(this).siblings(selectors.filtersAccordianContent).slideUp(200);
      } else {
        $(selectors.filtersAccordianTrigger).removeClass("is-active");
        $(this).addClass("is-active");
        $(selectors.filtersAccordianContent).slideUp(200);
        $(this).siblings(selectors.filtersAccordianContent).slideDown(200);
      }
    });

    $(selectors.filtersTrigger).on("click", function () {
      $(selectors.collectionFilters).addClass("is-opened");
      setTimeout(function () {
        $("body").addClass("lock");
      }, 200);
    });

    $(selectors.collectionFiltersClose).on("click", function () {
      $(selectors.collectionFilters).removeClass("is-opened");
      $("body").removeClass("lock");
    });
  }

  filtersAccordian();
  return filtersAccordian;
})();
theme.IntroCarousel = (function () {
  var selectors = {
    introCarouselWrapp: ".js-intro-carousel",
  };

  function introCarousel() {
    $(selectors.introCarouselWrapp).slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 340,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  introCarousel();

  return introCarousel;
})();
theme.InfoCarousel = (function () {
  var selectors = {
    infoCarouselWrapp: ".js-info-carousel",
  };

  function infoCarousel() {
    $(selectors.infoCarouselWrapp).slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }

  infoCarousel();

  return infoCarousel;
})();

theme.ProductCarousel = (function () {
  var selectors = {
    thumbCarousel: ".js-carousel-thumb",
    previewCarousel: ".js-carousel-preview",
  };

  function productCarousel() {
    $(selectors.thumbCarousel).slick({
      dots: false,
      infinite: true,
      speed: 400,
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: $(selectors.previewCarousel),
      focusOnSelect: true,
    });
    $(selectors.previewCarousel).slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      cssEase: "linear",
      asNavFor: $(selectors.thumbCarousel),
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
    lightbox.option({
      resizeDuration: 100,
      wrapAround: true,
      fitImagesInViewport: false,
      disableScrolling: true,
    });
  }

  productCarousel();

  return productCarousel;
})();
theme.ProductSelect = (function () {
  var selectors = {
    selectSize: ".js-select-product-size",
  };

  function formatInput(state) {
    if (state.id && state.disabled) {
      return $(
        "<span class='text'>" +
        state.text +
        "</span><span class='not' onclick='preselectEmailme(this);' data-selection='" +
        state.id +
        "'>Notify me</span>"
      );
    }

    return $("<span class='text'>" + state.text + "</span>");
  }

  function productSelect() {
    $(selectors.selectSize).select2({
      minimumResultsForSearch: -1,
      width: "resolve",
      templateResult: formatInput,
    });
  }

  productSelect();

  return productSelect;
})();

theme.NewArticleCarousel = (function () {
  var selectors = {
    articleCarouselWrapp: ".js-new-article-carousel",
  };

  function newArticleCarousel() {
    $(selectors.articleCarouselWrapp).slick({
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }

  newArticleCarousel();

  return newArticleCarousel;
})();
theme.VideoModal = (function () {
  var selectors = {
    videoModalTrigger: ".js-modal-video",
  };

  function videoModal() {
    $(selectors.videoModalTrigger).modalVideo({
      channel: "youtube",
    });
  }

  videoModal();

  return videoModal;
})();
theme.CollectionItemSize = (function () {
  var selectors = {
    collectionSizeParent: ".js-collection-item-size li",
    collectionSizeTrigger: ".js-collection-item-size li a",
  };

  function collectionItemSize() {
    $(selectors.collectionSizeTrigger).on("click", function (e) {
      e.preventDefault();
      const dataValue = $(this).data("value");
      $(this)
        .closest(".collection-list-item")
        .find(selectors.collectionSizeParent)
        .removeClass("is-active");
      $(this).parent().addClass("is-active");
      $(this).closest(".collection-list-item").find("select").val(dataValue);
    });
  }
  collectionItemSize();

  return collectionItemSize;
})();

theme.CollectionSortBy = (function () {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  function collectionSortBy() {
    var selectedIndex = $("#sortBy").prop("selectedIndex");
    var selector = "#sortBy";

    $(selector)
      // select the current sort order
      .val("{{ collection.sort_by | default: collection.default_sort_by }}")
      .bind("change", function () {
        Shopify.queryParams.sort_by = jQuery(this).val();
        location.search = jQuery.param(Shopify.queryParams);
      });

    $(selector).prop("selectedIndex", selectedIndex);
  }

  collectionSortBy();

  return collectionSortBy();
})();
theme.ShowPerPage = (function () {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  function showPerPage() {
    //Update products per page
    $("#showPerPage").bind("change", function () {
      window.location.replace(jQuery(this).val());
    });
  }
  showPerPage();

  return showPerPage();
})();
theme.updateCart = (function () {
  var selectors = {
    selectQty: ".cart__item-quantity select",
  };
  function updateCartQty() {
    $(selectors.selectQty).bind("change", function () {
      var index = jQuery(this).find(":selected").data("index");
      ///cart/change?line={{ forloop.index }}&amp;quantity=0
      window.location.replace(
        "cart/change?line=" + index + "&quantity=" + jQuery(this).val()
      );
    });
  }
  return updateCartQty();
})();

theme.tabs = (function () {
  jQuery("ul.tabs").each(function () {
    var active,
      content,
      links = jQuery(this).find("a");
    active = links.first().addClass("active");
    content = jQuery(active.attr("href"));
    links.not(":first").each(function () {
      jQuery(jQuery(this).attr("href")).hide();
    });
    jQuery(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = jQuery(this);
        content = jQuery(jQuery(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("navigation", theme.Navigation);
  sections.register("filters-accordian", theme.FiltersAccordian);
  sections.register("intro-carousel", theme.IntroCarousel);
  sections.register("info-carousel", theme.InfoCarousel);
  sections.register("product-carousel", theme.InfoCarousel);
  sections.register("product-select", theme.ProductSelect);
  sections.register("new-article-carousel", theme.NewArticleCarousel);
  sections.register("video-modal", theme.VideoModal);
  sections.register("collection-item-size", theme.CollectionItemSize);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }
});

$(document).ready(function () {
  if ($("body").is("#press")) {
    jQuery("div.press-features__item .open-popup").click(function (e) {
      e.preventDefault();
      jQuery(".black-overlay").show();
      jQuery(this).next().slideDown();
    });
  }

  if ($("body").is(".template-collection")) {
    jQuery(".collection-list-item__trigger-similar").click(function (e) {
      e.preventDefault();

      var target = "#popup-" + jQuery(this).data("target");

      jQuery("div.background").show();
      jQuery(target).show();
      jQuery(target).find(".slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: "linear",
      });
    });

    jQuery(".collection-list-item__outer span.close").click(function () {
      jQuery("div.background").hide();
      jQuery(".collection-list-item__outer").hide();
    });

    jQuery(".responsive.responsive-filters button").click(function () {
      var container = jQuery(
        "body.template-collection aside.collection-filters .collection-filters__accordion"
      );

      if (jQuery(container).is(":visible")) {
        jQuery(container).slideUp();
      } else {
        jQuery(container).slideDown();
      }
    });

    jQuery(".responsive.new-responsive-filters button").click(function () {
      if (jQuery("div.new-filters-container").is(":visible")) {
        jQuery("div.new-filters-container").slideUp();
      } else {
        jQuery("div.new-filters-container").slideDown();
      }
    });

    if (parseInt(jQuery(document).width()) < 701) {
      jQuery(
        ".collection-list-item__inner .collection-list-item__info-size a"
      ).each(function () {
        var text = jQuery(this).html();

        if (text.indexOf("US") > 0) {
          text = text.split(" ").join("");
          text = text.replace("US", " US");
          jQuery(this).html(text);
        }
      });
    }

    jQuery(document).ready(function () {
      jQuery(
        ".collection-list__products .collection-list-item ul.collection-list-item__info-size li"
      ).each(function () {
        if (jQuery(this).is(".skipconversion")) return;
        var link = jQuery(this).find("a");
        var label = link.html();

        if (label.indexOf("/") > 0 && label.indexOf("US") > 0) {
          var newLabel = label.substring(0, label.indexOf("/")).trim();
          jQuery(link).html(newLabel);
        }
      });
    });

    stickyNavigation();

    jQuery(window).scroll(function () {
      stickyNavigation();
    });

    jQuery(".custom-list-tags input[type='checkbox']").each(function () {
      jQuery(this).on("change", function (e) {
        jQuery(this).closest(".filter").find(".clearall.apply").show();
      });
    });

    jQuery("#shopify-section-collection-filters .clearall.apply a").click(
      function (e) {
        e.preventDefault();

        var baseUrl = jQuery(this).attr("href");

        jQuery(
          ".collection-filters__accordion .custom-list-tags input:checked"
        ).each(function () {
          baseUrl = baseUrl + jQuery(this).val() + "+";
        });

        baseUrl = baseUrl.substring(0, baseUrl.length - 1);

        window.location.href = baseUrl;
      }
    );

    jQuery(".new-filters-container .clearall.apply a").click(function (e) {
      e.preventDefault();

      var baseUrl = jQuery(this).attr("href");

      jQuery(".new-filters-container .filter input:checked").each(function () {
        baseUrl = baseUrl + jQuery(this).val() + "+";
      });

      baseUrl = baseUrl.substring(0, baseUrl.length - 1);

      window.location.href = baseUrl;
    });

    jQuery(".new-filters-container li.showmore a").click(function (e) {
      e.preventDefault();
      jQuery(this).parent().parent().find("li").show();
    });
  }

  if ($("body").is(".template-product")) {
    if (parseInt($(window).width()) <= 750) {
      $(
        "body.template-product #shopify-section-product-general-info .product-general-info__item h3"
      ).click(function () {
        var container = $(this).next();

        if ($(container).is(":visible")) {
          $(container).slideUp();
        } else {
          $(container).slideDown();
        }
      });
    }

    taxEstimateRefresh();
    hideEmptyReviews();
    preselectProductOption();

    jQuery("form .product-details__info-trigger-add").click(function () {
      _ltk.SCA.AddItemWithLinks(
        productData.sku,
        jQuery("#Quantity").val(),
        productData.price / 100,
        productData.title,
        productData.image,
        productData.url
      );

      for (var key in cartdata.items) {
        var item = cartdata.items[key];
        _ltk.SCA.AddItemWithLinks(
          item.sku,
          item.quantity,
          item.price / 100,
          item.title,
          item.image,
          item.url
        );
      }

      _ltk.SCA.Submit();
    });

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(swymCallbackFn);

    jQuery("select[name='id']").on("select2:select", function (e) {
      trackListrakProductBrowse();
    });

    jQuery(".product-page-thumbnail").click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      var imgSrc = jQuery(this).find("img").attr("src");
      var imgIndex = jQuery(this).data("lightindex");
      var mainImgSrc = jQuery("div.bigimage a img").attr("src");
      var maingImgIndex = jQuery("div.bigimage a").data("lightindex");

      jQuery("div.bigimage a img").attr("src", imgSrc);
      //jQuery(this).find("img").attr("src", mainImgSrc);
      jQuery(this).data("lightindex", maingImgIndex);
      jQuery("div.bigimage a").data("lightindex", imgIndex);

      return false;
    });

    jQuery("div.bigimage a").click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      var targetIndex = jQuery(this).data("lightindex");
      jQuery(".product-details__carousel-preview .slick-slide a").each(function () {
        if (jQuery(this).data("lightindex") == targetIndex) {
          jQuery(this).trigger("click");
        }
      });

      return false;
    });
  }

  if ($("body").is(".template-cart")) {
    jQuery("div.cart__item a.cart__item-cta-btn").click(function () {
      var removingItem = jQuery(this).data("line");

      for (var key in cartdata.items) {
        var checkData = parseInt(key) + 1;

        if (checkData == removingItem) {
          continue;
        }

        var item = cartdata.items[key];
        _ltk.SCA.AddItemWithLinks(
          item.sku,
          item.quantity,
          item.price / 100,
          item.title,
          item.image,
          item.url
        );
      }

      _ltk.SCA.Submit();
    });

    jQuery("select#Quantity").change(function () {
      return;

      var removingItem = jQuery(this).data("line");
      var newQty = parseInt(jQuery(this).data("line"));

      for (var key in cartdata.items) {
        var item = cartdata.items[key];
        var checkData = parseInt(key) + 1;
        var quantity = item.quantity;

        if (checkData == removingItem) {
          if (newQty == 0) {
            continue;
          }

          quantity = newQty;
        }

        _ltk.SCA.AddItemWithLinks(
          item.sku,
          quantity,
          item.price / 100,
          item.title,
          item.image,
          item.url
        );
      }

      _ltk.SCA.Submit();
    });

    jQuery(".go-to-checkout").click(function () {
      jQuery([document.documentElement, document.body]).animate(
        {
          scrollTop: jQuery(".cart__total").offset().top,
        },
        500
      );
    });

    jQuery(window).scroll(function () {
      if (parseInt(jQuery(window).width()) > 900) {
        var topScroll = $(window).scrollTop();
        if (topScroll > 270) {
          if (
            parseInt(
              jQuery(
                "section.cart .sidebar.cart__total .sidebar_content"
              ).height()
            ) +
            (topScroll - 270 + 60) >
            parseInt(jQuery("section.cart .container .cart_content").height())
          ) {
            return;
          }

          jQuery("section.cart .sidebar.cart__total .sidebar_content")
            .css("position", "absolute")
            .css("top", topScroll - 270 + 20 + "px");
        } else {
          jQuery("section.cart .sidebar.cart__total .sidebar_content")
            .css("position", "relative")
            .css("top", "auto");
        }
      }
    });
  }

  if ($("body").is(".template-page")) {
    $("#responsive-customer-service-menu").change(function () {
      var url = $(this).val();
      document.location.href = url;
    });
  }

  if ($("body").is(".template-login")) {
    $("#ShowRecoverPasswordLink").click(function (e) {
      e.preventDefault();
      $("#forgotPasswordForm").slideDown();
    });

    $("#HideRecoverPasswordLink").click(function (e) {
      e.preventDefault();
      $("#forgotPasswordForm").slideUp();
    });

    if (location.hash == "#recover") {
      $("#forgotPasswordForm").show();
    }

    $('#create_customer').submit(function (e) {
      $(this).find('.myloader').show();
      $(this).find('input[type="submit"]').hide();
      localStorage.setItem('account_redirect', '/account');

      if (document.referrer == 'https://hampdenclothing.com/pages/style-set-rewards') {
        localStorage.setItem('account_redirect', '/pages/style-set-rewards-account');
      }
    });

    $('#customer_login').submit(function (e) {
      $(this).find('.myloader').show();
      $(this).find('input[type="submit"]').hide();
      localStorage.setItem('account_redirect', '/account');

      if (document.referrer == 'https://hampdenclothing.com/pages/style-set-rewards') {
        localStorage.setItem('account_redirect', '/pages/style-set-rewards-account');
      }
    });

    $('div.tabselectors span').click(function () {
      $('div.tabselectors span').removeClass("active");
      $(this).addClass("active");

      $('div.account__col').hide()
      if ($(this).is(".logn")) {
        $('div.account__col.logn').show();
      } else {
        $('div.account__col.regist').show();
      }

    });
  }

  if ($("body").is("#designers")) {
    if (window.location.hash) {
      var targetLetter = window.location.hash;
      targetLetter = targetLetter.replace("#", "");

      if (jQuery("#" + targetLetter).length) {
        jQuery([document.documentElement, document.body]).animate(
          {
            scrollTop: jQuery("#" + targetLetter).offset().top,
          },
          400
        );
      }
    }
  }

  if ($("body").is(".template-blog")) {
    if (parseInt($(window).width()) < 990) {
      jQuery("div.selected-posts").find(".slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: "linear",
        slidesToShow: 2,
      });

      jQuery("div.stylist-section").find(".slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: "linear",
        slidesToShow: 1,
      });
    }
  }



  $("#footer_newsletter_button").click(function () {
    validateNewsletter($("#footer_newsletter"));
  });

  $("#header_newsletter").change(function () {
    validateNewsletter($("#header_newsletter"));
  });

  $("#mobile_header_newsletter").change(function () {
    validateNewsletter($("#mobile_header_newsletter"));
  });

  $("#header-shop-the-edits").change(function () {
    var url = $(this).find(":selected").attr("value");
    if (url.length > 2) {
      window.top.location.href = url;
    }
  });

  $(".collection-toolbar-bottom select#sortBy").change(function () {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
  });

  $(".collection-toolbar-bottom select#showPerPage").change(function () {
    window.top.location.href = jQuery(this).val();
  });

  $(".product-details__info-order-details-available").click(function () {
    $(this).parent().find(".emailme").fadeIn();
  });

  $("#emailmebutton").click(function () {
    var email = $("#emailmemail").val();

    $("#emailmemail").css("border-color", "#f6f6f6");
    $("#emailmesize").css("border-color", "#f6f6f6");

    if (!validateEmail(email)) {
      $("#emailmemail").css("border-color", "#990000");
      return;
    }

    if ($("#emailmesize").val() == 0) {
      $("#emailmesize").css("border-color", "#990000");
      return;
    }

    lisSubmitAlert($("#emailmesize").val(), email, "PA");

    $(".emailme").addClass("activated");
  });

  $(".emailme .close").click(function () {
    $(this).closest(".emailme").fadeOut();
  });

  if (jQuery("div.stylists").length > 0) {
    jQuery("div.stylists .grid").slick({
      dots: false,
      infinite: true,
      speed: 500,
      cssEase: "linear",
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    jQuery("div.stylists")
      .parent()
      .attr("role", "region")
      .attr("aria-label", "carousel");
  }

  if (parseInt($(window).width()) < 990) {
    if (jQuery(".home-press").length > 0) {
      jQuery(".home-press .logos").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: "linear",
        slidesToShow: 2,
        slidesToScroll: 1,
      });

      jQuery(".home-press")
        .parent()
        .attr("role", "region")
        .attr("aria-label", "carousel");
    }
  }

  //only responsive
  if (parseInt($(window).width()) < 990) {
    $(".header__nav li.header__nav-list-item > a").click(function (e) {
      if (
        jQuery(this).parent().find("div.header__nav-list-item-dropdown")
          .length &&
        !jQuery(this).parent().is(".is-active")
      )
        e.preventDefault();
    });
  }

  //if(window.location.hostname !== "hampdenclothing.com" && window.location.hostname !== "hampdenclothing.myshopify.com") { window.top.location = "https://hampdenclothing.com/"; }

  $(".header__service-menu li a.mobile-search").click(function (e) {
    e.preventDefault();
    jQuery("div.mobile-search-form").slideDown();
  });

  $(".header__nav-list-item.shoes .main-nav-content ul li a").each(function () {
    if ($(this).html().startsWith("ALL")) {
      $(this).css("font-weight", "bold");
    }
  });
});

function trackListrakProductBrowse() {
  var variantId = jQuery("select[name='id']").val();
  var variantSku = false;

  for (i = 0; i < meta.product.variants.length; i++) {
    var variant = meta.product.variants[i];

    if (variant.id == variantId) {
      console.log(variant.sku);
    }
  }

  if (variantSku) {
    _ltk.Activity.AddProductBrowse(variantSku);
  }
}

function preselectProductOption() {
  var selected = false;

  jQuery(".js-select-product-size")
    .find("option")
    .each(function () {
      if (
        parseInt(jQuery(this).val()) > 0 &&
        !jQuery(this).prop("disabled") &&
        !selected
      ) {
        jQuery(this).prop("selected", true);
        selected = true;
        jQuery("span.select2-selection__rendered").html(jQuery(this).html());
        trackListrakProductBrowse();
      }
    });
}

function preselectEmailme(e) {
  var value = jQuery(e).data("selection");

  jQuery(".emailme option").each(function () {
    if (jQuery(this).data("id") == value) {
      jQuery(this).attr("selected", "selected");
    }
  });

  jQuery(".emailme").fadeIn();
}

function stickyNavigation() {
  if (parseInt($(window).width()) > 990) {
    if (parseInt(jQuery(this).scrollTop()) > 150) {
      jQuery("body").addClass("sticky-nav");
    } else {
      jQuery("body").removeClass("sticky-nav");
    }

    if (parseInt(jQuery(this).scrollTop()) > 218) {
      jQuery("body").addClass("sticky-filter");
    } else {
      jQuery("body").removeClass("sticky-filter");
    }
  }
}

function taxEstimateRefresh() {
  if (jQuery("div.zonos-estimate").html().length > 0) {
    return;
  }

  if (
    jQuery("body.z-intl #zonos div.z-bubble").length &&
    jQuery("body.z-intl #zonos div.z-bubble").html().length > 0
  ) {
    jQuery("div.zonos-estimate")
      .html(jQuery("body.z-intl #zonos div.z-bubble").html())
      .show();
  } else {
    setTimeout(taxEstimateRefresh, 500);
  }
}

function hideEmptyReviews() {
  if (jQuery(".product-details__info .yotpo-bottomline .sr-only").length) {
    if (
      jQuery(".product-details__info .yotpo-bottomline .sr-only").html() !=
      "0.0 star rating"
    ) {
      jQuery(".product-details__info .yotpo-bottomline").show();
    }
  } else {
    setTimeout(hideEmptyReviews, 500);
  }
}

/* Called when swym is loaded! */
function swymCallbackFn(swat) {
  $("select.js-select-product-size").change(function () {
    var variantId = $("select.js-select-product-size").val();
    window.triggerSwymVariantEvent(variantId);
    swat.initializeActionButtons(".product-page-wishlist-grid");
  });
}

function lisSubmitAlert(productSKU, emailAddress, alertCode) {
  _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
  _ltk.Alerts.Submit();
}

function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function closeOverlay() {
  jQuery(".black-overlay").hide();
  jQuery("div.press-features__item div.more_info").each(function () {
    jQuery(this).hide();
  });
}

function validateNewsletter(element) {
  jQuery(element).removeClass("invalid");

  if (jQuery(element).val() == "") {
    jQuery(element).attr("placeholder", "Please add a valid e-mail");
  } else if (!validateEmail(jQuery(element).val())) {
    jQuery(element).addClass("invalid");
    return false;
  }

  setTimeout(function () {
    jQuery("footer .footer__newsletter").hide();
    jQuery("footer .footer__newsletter__thankyou").show();
  }, 1500);

  return true;
}

function fillMiniCart() {
  jQuery
    .ajax({
      url: "/cart.js",
      dataType: "json",
    })
    .done(function (data) {
      jQuery("#minicart .cart-items .item").each(function () {
        if (!jQuery(this).is(".dummy")) {
          jQuery(this).remove();
        }
      });

      // TRYNOW BEGIN
      var tryNowSubtotal = 0

      for (var i = 0; i < data.items.length; i++) {
        var item = data.items[i];
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')) {
          tryNowSubtotal = tryNowSubtotal + item.final_line_price
        }
        addMiniCartItem(item, i);
      }

      if (tryNowSubtotal > 0) {
        jQuery("#minicart .totals .grandtotal span.value").html('$' + ((data.total_price - tryNowSubtotal) / 100).toFixed(2)).css('font-size', '16px');
        jQuery("#minicart .totals .grandtotal span.label")
          .text('Amount Due Today')
          .css('font-size', '12px');
      } else {
        var total = jQuery(".currencyformat")
          .html()
          .replace(
            "0.00",
            numberWithCommas((data.total_price / 100).toFixed(2))
          );
        jQuery("#minicart .totals .grandtotal span.value").html(total);
        jQuery("#minicart .totals .grandtotal span.label")
          .text('Subtotal')
          .css('font-size', '12px');
      }
      // TRYNOW END

      jQuery("a.minicartlink .item-number").html(data.item_count);
    });
}

function addMiniCartItem(item, line) {
  var newItem = jQuery("#minicart .cart-items .dummy")
    .clone()
    .removeClass("dummy");

  jQuery(newItem)
    .find(".image img")
    .attr("src", item.image)
    .attr("alt", item.product_title);

  if (item.url) {
    jQuery
      .ajax({
        url: item.url,
        dataType: "json",
      })
      .done(function (data) {
        var tags = data.product.tags.split(",");
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].trim() == "sale") {
            jQuery("#minicart .cart-items")
              .find(newItem)
              .find(".details h5")
              .after("<br/><span class='saletag'>FINAL SALE</span>");
          }
        }
      });
  }

  jQuery(newItem).find(".details h5").html(item.product_title);

  // TryNow Code
  const hasTrySellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.toLowerCase().includes('try');

  var price = jQuery(".currencyformat")
    .html()
    .replace("0.00", (item.final_price / 100).toFixed(2));
  if (hasTrySellingPlan) {
    jQuery(newItem).find(".details .item-price").html(`<span style="text-decoration: line-through; width: auto; margin-right: 2px;">$${(item.final_price / 100).toFixed(2)}</span> $0.00`);
  } else {
    jQuery(newItem).find(".details .item-price").html(price);
  }

  if (hasTrySellingPlan) {
    jQuery(newItem).find(".details .trynow-selling-plan").html(item.selling_plan_allocation.selling_plan.name);
  }
  // TryNow Code

  jQuery(newItem)
    .find(".qty select")
    .val(item.quantity)
    .data("id", line + 1);

  jQuery("#minicart .cart-items").append(newItem);
}

function updateMinicartItem(line, qty) {
  jQuery
    .ajax({
      url: "/cart/change?line=" + line + "&quantity=" + qty,
    })
    .done(function (data) {
      fillMiniCart();
    });
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function syncMiniCartChatVisibility() {
  const isMiniCartOpen = jQuery("#minicart").hasClass("open");

  jQuery("body").toggleClass("minicart-open", isMiniCartOpen);

  document
    .querySelectorAll("inbox-online-store-chat, #ShopifyChat")
    .forEach(function (chatHost) {
      if (isMiniCartOpen) {
        chatHost.style.setProperty("display", "none", "important");
        chatHost.style.setProperty("visibility", "hidden", "important");
        chatHost.style.setProperty("pointer-events", "none", "important");
      } else {
        chatHost.style.removeProperty("display");
        chatHost.style.removeProperty("visibility");
        chatHost.style.removeProperty("pointer-events");
      }
    });
}

jQuery(document).ready(function () {
  fillMiniCart();

  syncMiniCartChatVisibility();

  const miniCart = document.querySelector("#minicart");
  if (miniCart) {
    new MutationObserver(syncMiniCartChatVisibility).observe(miniCart, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  if (document.body) {
    new MutationObserver(syncMiniCartChatVisibility).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  jQuery("#minicart .content span.close").click(function () {
    jQuery("#minicart").removeClass("open");
  });

  jQuery("#minicart").on("change", ".input-increment__number", function () {
    updateMinicartItem(jQuery(this).data("id"), jQuery(this).val());
  });

  jQuery("a.minicartlink").click(function (e) {
    if (parseInt(jQuery(this).find(".item-number").html()) > 0) {
      e.preventDefault();
      jQuery("#minicart").addClass("open");
    }
  });
});

document.addEventListener("DOMContentLoaded", function (event) {
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector(".row.coupon_cont");
  let discountCodeValue = document.querySelector(
    ".applied-discount-code-value"
  );
  let discountCodeInput = document.querySelector("#discount-code-input");
  let totalCartSelector = document.querySelector(
    ".cart__total .row.total .money"
  ); // Total Cart Selector to update the total amount.
  let discountTotalRow = document.querySelector(".row.discount");
  let authorization_token;

  let checkoutContainer = document.createElement("div");
  document.body.appendChild(checkoutContainer);
  if (localStorage.discountCode)
    applyDiscount(JSON.parse(localStorage.discountCode).code);
  applyBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    applyDiscount(discountCodeInput.value);
  });
  clearBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    clearDiscount();
  });
  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    discountCodeInput.value = "";
    applyBtn.style.display = "block";
    clearBtn.style.display = "none";
    fetch("/checkout?discount=%20");
  }
  function clearLocalStorage() {
    discountTotalRow.style.display = "none";
    if (localStorage.discountCode) {
      totalCartSelector.innerHTML = JSON.parse(
        localStorage.discountCode
      ).totalCart;
      localStorage.removeItem("discountCode");
    }
  }
  function applyDiscount(code) {
    applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
    applyBtn.style.pointerEvents = "none";
    fetch("/payments/config", { method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const checkout_json_url = "/wallets/checkouts/";
        authorization_token = btoa(data.paymentInstruments.accessToken);
        fetch("/cart.js", {})
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            let body = {
              checkout: {
                country: Shopify.country,
                reduction_code: code,
                line_items: data.items,
                presentment_currency: Shopify.currency.active,
              },
            };
            fetch(checkout_json_url, {
              headers: {
                accept: "*/*",
                "cache-control": "no-cache",
                authorization: "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                pragma: "no-cache",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
              },
              referrerPolicy: "strict-origin-when-cross-origin",
              method: "POST",
              mode: "cors",
              credentials: "include",
              body: JSON.stringify(body),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (data) {
                console.log(data.checkout);
                if (
                  parseFloat(data.checkout.payment_due) <
                  parseFloat(data.checkout.total_line_items_price)
                ) {
                  if (data.checkout.gift_cards.length > 0) {
                    discountCodeError.innerHTML = "";
                    discountCodeValue.innerHTML =
                      "****" +
                      data.checkout.gift_cards[0].last_characters +
                      " (" +
                      data.checkout.gift_cards[0].amount_used +
                      " " +
                      Shopify.currency.active +
                      ")";
                  } else {
                    discountCodeError.innerHTML = "";
                    discountCodeValue.innerHTML =
                      data.checkout.applied_discounts[0].title +
                      " (" +
                      data.checkout.applied_discounts[0].amount +
                      " " +
                      Shopify.currency.active +
                      ")";
                  }

                  discountCodeWrapper.style.display = "inline";
                  discountTotalRow.style.display = "block";
                  let localStorageValue = {
                    code: code.trim(),
                    totalCart: data.checkout.total_line_items_price,
                  };
                  localStorage.setItem(
                    "discountCode",
                    JSON.stringify(localStorageValue)
                  );
                  totalCartSelector.innerHTML =
                    data.checkout.currency_format.symbol +
                    data.checkout.payment_due;
                  applyBtn.style.display = "none";
                  clearBtn.style.display = "block";
                } else {
                  discountCodeValue.innerHTML = "";
                  clearLocalStorage();
                  discountCodeError.innerHTML =
                    "Please Enter Valid Coupon Code.";
                  applyBtn.style.display = "block";
                  clearBtn.style.display = "none";
                }
              })
              .finally(function (params) {
                applyBtn.innerHTML = "APPLY";
                applyBtn.style.pointerEvents = "all";
              });
          });
      });
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  const cpBlockContainer = document.querySelector('#tn-hiw-container'); // replace with your actual parent ID or class

  if (cpBlockContainer) {
    Array.from(cpBlockContainer.children).forEach(child => {
      console.log(child);
      if (!child.classList.contains('tn-hiw-steps-container')) {
        child.style.display = 'none';
      }
    });

  }

})
